module.exports = __webpack_public_path__ + "static/media/pointing-arm.9facbd66.svg";